<template>
  <div class="patient-alert-report-page">
    <h6>Relatório de alertas de pacientes</h6>

    <div class="form-group">
      <label class="form-switch">
        <input type="checkbox" v-model="allPeriod">
        <i class="form-icon"></i> Todo o período
      </label>
    </div>
    <div class="columns form-group" style="margin-bottom: 1rem;">
      <div
        class="column col-6 col-md-6 col-sm-12 form-group"
        :class="{'has-error': $v.filters.startDate.$error || $v.filters.endDate.$error}"
      >
        <label class="form-label">Período</label>
        <st-date-period
          :start-date.sync="filters.startDate"
          :end-date.sync="filters.endDate"
          :start-date-validator="$v.filters.startDate"
          :end-date-validator="$v.filters.endDate"
          :disabled="allPeriod"
          @blur:startDate="$v.filters.startDate.$touch()"
          @blur:endDate="$v.filters.endDate.$touch()"
        />
      </div>
    </div>

    <div class="footer">
      <st-button-report
        type="pdf"
        button-class="btn-info"
        route="/reports/patient-alert"
        :options="[]"
        :params="reportParams"
        :validator="reportValidator"
      ></st-button-report>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { date, minDate } from '@/data/validators';
import formMixin from '@/mixins/form';

export default {
  mixins: [formMixin],
  props: {
    startDate: {
      type: String,
    },
    endDate: {
      type: String,
    },
  },
  data() {
    return {
      allPeriod: false,
      filters: {
        startDate: '',
        endDate: '',
      },
    };
  },
  validations() {
    const rules = {
      filters: {
        startDate: {},
        endDate: {},
      },
    };

    if (!this.allPeriod) {
      rules.filters.startDate.date = date;
      rules.filters.endDate.date = date;

      if (this.filters.startDate) {
        rules.filters.endDate.minDate = minDate(this.filters.startDate);
      }
    }

    return rules;
  },
  mounted() {
    this.filters.startDate = moment()
      .startOf('month')
      .format('YYYY-MM-DD');
    this.filters.endDate = moment()
      .endOf('month')
      .format('YYYY-MM-DD');
  },
  computed: {
    reportParams() {
      const params = {};
      if (!this.allPeriod) {
        params.startDate = this.filters.startDate;
        params.endDate = this.filters.endDate;
      }
      return params;
    },
  },
  methods: {
    reportValidator() {
      this.$v.filters.$touch();
      if (this.$v.filters.$error) {
        return false;
      }

      const duration = moment.duration(moment(this.filters.endDate)
        .diff(moment(this.filters.startDate))).asMonths();

      if (duration > 6) {
        this.$toast.show('Período limite (6 meses)', { type: 'error' });
        return false;
      }

      return true;
    },
  },
};
</script>

<style lang="scss">
  @import "../../../assets/scss/variables";
  @import '~assets/scss/mixins';
  .patient-alert-report-page {
    .footer {
      margin-top: $layout-spacing-lg;
      text-align: right;
    }
  }
</style>
